export default {


    // how many more can be added for the current number of adults
    // minimum of one adult per hebergement
    remainingAdditionalHebergements: (state)=>{
        const participants = state.participants
        const selectedPrestIds = state.selectedPrestIds
        const adultParticipants_no = participants.filter(num=>num===18).length

        let totalSelectedHebergements = 0

        Object.values(selectedPrestIds).forEach((val)=>{
            totalSelectedHebergements += val
        })

        const remaining = adultParticipants_no - totalSelectedHebergements
        if (remaining<0) throw new Error('remaining cannot be negative')
        return remaining
    },

}